import { css, styled } from 'styled-components';

export interface IScFlipWrapper {
  isFlipped?: boolean;
  width?: string;
  height?: string;
}

export const ScFlipWrapper = styled.div<IScFlipWrapper>`
  position: relative;
  transition: transform 1s;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  perspective: 2000px;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  margin-inline: auto;
  max-width: 100%;

  & .front,
  & .back {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: transform 1s;
    ${({ isFlipped }) =>
      isFlipped &&
      css`
        transform: rotateY(-180deg);
      `};
  }

  & .back {
    height: 100%;
    overflow: hidden;
    transform: rotateY(180deg);
    ${({ isFlipped }) =>
      isFlipped &&
      css`
        transform: rotateY(0deg);
      `};
  }
`;
